 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		123: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		123: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"38268e420db6e3eeb5eb","1":"ee75f6bb497f9d28a4f7","2":"279bf84635eaa6d05c1d","3":"668e54b206169804c31f","4":"5d646d88945d1fea7443","5":"5599aece9db79fff7fa2","6":"db3542b2d7d26b71b1e3","7":"fa01dc948fbd1e533aa9","8":"896031a13c7574568bc2","9":"4dc177e88955c5864f9f","10":"de77033e9c1a9a60f1d6","11":"eeb252c0549a23eef3d8","12":"d572b2977968bc539677","13":"7f627675dd31db1ecdb8","14":"954dad9e8b7aeb14b563","15":"9d6eca273e11719eb19a","16":"86f3f15d0d79340a0175","17":"9545ace64f49bd8a6418","18":"eb918e0a0833577551f0","19":"949b170cfd39a9083c54","20":"fef79c9222f64afdbe60","21":"90b13b6ba5d6e3049041","22":"a6e1f87ee26c0d45b2d1","23":"bd66fcff033eef8b2df6","24":"4f4f6524c17398bd1ace","25":"4205974a8d0eaafab0ff","26":"963701e764a61af82a7b","27":"d322432102a332f68241","28":"f119b0551808aa0f0001","29":"7b5f64926e187d8099f3","30":"3acf78e264ed85441728","31":"752e51eff55c65d693b9","32":"afbfb23921fa1a180c6b","33":"9a091432826671c352e3","34":"47c4cfa597dd3f2606a3","35":"1d738339312b58b73502","36":"02a83ae2ecd87969e163","37":"10bda7aa3980aca8b7a3","38":"30a70d253104162f741e","39":"981ef62ce83fe3efae86","40":"ecfe84642f164824b3d5","41":"437dc4bf625742d0dba3","42":"fb52b6d54716c2b67119","43":"05d92f40699b8a27cc82","44":"f279ab7cf916685373e3","45":"67b76251b2aba3a75bb4","46":"d3b6991cc2189b9e1fa0","47":"ba054de3f4b6e9567941","48":"ce8b1e81e96c3917062c","49":"1545f1e5367994a56a63","50":"c6b581fce7aff0d87d40","51":"ca79429e4ec3adabd795","52":"21efe96c7901c3512913","53":"db18d2c9e5fc7b3c324e","54":"aa88424b55eb53700056","55":"158b4f6593fbbd16984d","56":"33b63d10c7868efd26db","57":"0b35e1f429312ae3e1a9","58":"728d7b615a39c85525cd","59":"b45a9b7f44c06de34e16","60":"100aa28345cbc701de03","61":"8e6e133034f748c50368","62":"0a82616df2264a501887","63":"05575d0f3902bb659746","64":"399ac2ba1a9dba9c1857","65":"41332cedc4bb1d157e10","66":"0d10ce0ee0bc3211c679","67":"3d10421a84e24c17f1bb","68":"ebd2876dd9e3b7c92912","69":"b43dd81c87627eb1758c","70":"fdff72b07eb318d42798","71":"5b2d3622eec3f5cb1b1e","72":"8c4333bebb1b6d6e1064","73":"4ec847ae0b4b3b300cd1","74":"44636dee6263cc14adfa","75":"a257ffd76ccda21a2465","76":"f104c0c99a81ff863204","77":"11139f3f6a1d11f8c8c3","78":"dc0a709fbec171200428","79":"e84e26222d2c7e0fcdc9","80":"a9881b4142bde9bc2bbc","81":"5342802a9aecca33ec0f","82":"a26f910d5124c7eaa14f","83":"e310352ac97f72cc7455","84":"22781c427777aaea053d","85":"f4db73f36873e702a5ca","86":"6d419778c0c14578e267","87":"2bb6329991bd32c9ba10","88":"b1f321485d581fe17784","89":"0dbfcba7fbd42834f2a0","90":"7ced5aa8910514767aeb","91":"e7b66d30ddc2375645c7","92":"133dc39c9daccc9b8d80","93":"3c643ed139e4c45fb410","94":"4d05149eddae6b0ee13c","95":"ed90456155a7222170b3","96":"2dcf1d3b86c241e23099","97":"6663fb7ed621cc0c20c7","98":"487fb748e936e6cb226e","99":"3896b985bc713071a45f","100":"6dc9a61f6225de5515be","101":"5ac296e62eb7c71d53aa","102":"3423e1071c08b87292a1","103":"bb26e42057361b5e3f3c","104":"6b64f7446b4ff906854a","105":"0113f7448e957824f938","106":"54f9c37cdc584748020a","107":"84b6a9e39fd75bc1c765","108":"0aaa368c5ff896283b05","109":"adbae03f2378aa033d00","110":"4ca72926a4535aa86d69","111":"febcc7eef6e2d1206ac3","112":"b713a61549921ee948b8","113":"041bf875e4583242736c","114":"710596ba66c8936c36dc","115":"8eb7a0854a622041b7d0","116":"8be9d40c1272d4058e42","117":"e439de424bf4aaeee64c","118":"72fffc3bbb4205c3cf88","119":"c92205b1b7cbe663b82b","120":"cb1935494161e8fd7515","121":"2a846dfdabdc423159ce","122":"995ac779c443358a5d1b","124":"a3716707d95c015a5abe","125":"964edaa102dc11841f0a","126":"eeaac2361c31a110099e","127":"f3a9f4abcbe194207fc3","128":"0da5cb77add6dd4e1143","129":"dac35529b7a6da79992d","130":"7ca5dcc0d477a0432e41","131":"f415220bc750e3ad352c","132":"8a15fa0c474b6f9d7480","133":"440b434b46f52e43161e","134":"a565bcc13e6295b3ffce","135":"99567f8b7a792cbfeb56","136":"03bbf2aca48ab118ea56","137":"9821e8d60c5527b190d7","138":"53c75f70235aec35fa33","139":"af0d63e6358881464e11"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"38268e420db6e3eeb5eb","1":"ee75f6bb497f9d28a4f7","2":"279bf84635eaa6d05c1d","3":"668e54b206169804c31f","4":"5d646d88945d1fea7443","5":"5599aece9db79fff7fa2","6":"db3542b2d7d26b71b1e3","7":"fa01dc948fbd1e533aa9","8":"896031a13c7574568bc2","9":"4dc177e88955c5864f9f","10":"de77033e9c1a9a60f1d6","11":"eeb252c0549a23eef3d8","12":"d572b2977968bc539677","13":"7f627675dd31db1ecdb8","14":"954dad9e8b7aeb14b563","15":"9d6eca273e11719eb19a","16":"86f3f15d0d79340a0175","17":"9545ace64f49bd8a6418","18":"eb918e0a0833577551f0","19":"949b170cfd39a9083c54","20":"fef79c9222f64afdbe60","21":"90b13b6ba5d6e3049041","22":"a6e1f87ee26c0d45b2d1","23":"bd66fcff033eef8b2df6","24":"4f4f6524c17398bd1ace","25":"4205974a8d0eaafab0ff","26":"963701e764a61af82a7b","27":"d322432102a332f68241","28":"f119b0551808aa0f0001","29":"7b5f64926e187d8099f3","30":"3acf78e264ed85441728","31":"752e51eff55c65d693b9","32":"afbfb23921fa1a180c6b","33":"9a091432826671c352e3","34":"47c4cfa597dd3f2606a3","35":"1d738339312b58b73502","36":"02a83ae2ecd87969e163","37":"10bda7aa3980aca8b7a3","38":"30a70d253104162f741e","39":"981ef62ce83fe3efae86","40":"ecfe84642f164824b3d5","41":"437dc4bf625742d0dba3","42":"fb52b6d54716c2b67119","43":"05d92f40699b8a27cc82","44":"f279ab7cf916685373e3","45":"67b76251b2aba3a75bb4","46":"d3b6991cc2189b9e1fa0","47":"ba054de3f4b6e9567941","48":"ce8b1e81e96c3917062c","49":"1545f1e5367994a56a63","50":"c6b581fce7aff0d87d40","51":"ca79429e4ec3adabd795","52":"21efe96c7901c3512913","53":"db18d2c9e5fc7b3c324e","54":"aa88424b55eb53700056","55":"158b4f6593fbbd16984d","56":"33b63d10c7868efd26db","57":"0b35e1f429312ae3e1a9","58":"728d7b615a39c85525cd","59":"b45a9b7f44c06de34e16","60":"100aa28345cbc701de03","61":"8e6e133034f748c50368","62":"0a82616df2264a501887","63":"05575d0f3902bb659746","64":"399ac2ba1a9dba9c1857","65":"41332cedc4bb1d157e10","66":"0d10ce0ee0bc3211c679","67":"3d10421a84e24c17f1bb","68":"ebd2876dd9e3b7c92912","69":"b43dd81c87627eb1758c","70":"fdff72b07eb318d42798","71":"5b2d3622eec3f5cb1b1e","72":"8c4333bebb1b6d6e1064","73":"4ec847ae0b4b3b300cd1","74":"44636dee6263cc14adfa","75":"a257ffd76ccda21a2465","76":"f104c0c99a81ff863204","77":"11139f3f6a1d11f8c8c3","78":"dc0a709fbec171200428","79":"e84e26222d2c7e0fcdc9","80":"a9881b4142bde9bc2bbc","81":"5342802a9aecca33ec0f","82":"a26f910d5124c7eaa14f","83":"e310352ac97f72cc7455","84":"22781c427777aaea053d","85":"f4db73f36873e702a5ca","86":"6d419778c0c14578e267","87":"2bb6329991bd32c9ba10","88":"b1f321485d581fe17784","89":"0dbfcba7fbd42834f2a0","90":"7ced5aa8910514767aeb","91":"e7b66d30ddc2375645c7","92":"133dc39c9daccc9b8d80","93":"3c643ed139e4c45fb410","94":"4d05149eddae6b0ee13c","95":"ed90456155a7222170b3","96":"2dcf1d3b86c241e23099","97":"6663fb7ed621cc0c20c7","98":"487fb748e936e6cb226e","99":"3896b985bc713071a45f","100":"6dc9a61f6225de5515be","101":"5ac296e62eb7c71d53aa","102":"3423e1071c08b87292a1","103":"bb26e42057361b5e3f3c","104":"6b64f7446b4ff906854a","105":"0113f7448e957824f938","106":"54f9c37cdc584748020a","107":"84b6a9e39fd75bc1c765","108":"0aaa368c5ff896283b05","109":"adbae03f2378aa033d00","110":"4ca72926a4535aa86d69","111":"febcc7eef6e2d1206ac3","112":"b713a61549921ee948b8","113":"041bf875e4583242736c","114":"710596ba66c8936c36dc","115":"8eb7a0854a622041b7d0","116":"8be9d40c1272d4058e42","117":"e439de424bf4aaeee64c","118":"72fffc3bbb4205c3cf88","119":"c92205b1b7cbe663b82b","120":"cb1935494161e8fd7515","121":"2a846dfdabdc423159ce","122":"995ac779c443358a5d1b","124":"a3716707d95c015a5abe","125":"964edaa102dc11841f0a","126":"eeaac2361c31a110099e","127":"f3a9f4abcbe194207fc3","128":"0da5cb77add6dd4e1143","129":"dac35529b7a6da79992d","130":"7ca5dcc0d477a0432e41","131":"f415220bc750e3ad352c","132":"8a15fa0c474b6f9d7480","133":"440b434b46f52e43161e","134":"a565bcc13e6295b3ffce","135":"99567f8b7a792cbfeb56","136":"03bbf2aca48ab118ea56","137":"9821e8d60c5527b190d7","138":"53c75f70235aec35fa33","139":"af0d63e6358881464e11"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function insert(linkTag) {
 				      if (document.querySelector('#assets-main-stylesheet')) {
 				        return;
 				      }
 				      document.head.appendChild(linkTag);
 				    })(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 779);
